var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.39 166.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff4ab;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #231f20;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.39,2l-15.55,157.96-4.8,1.24c-19.18,4.96-46.79,4.9-65.94-.18l-6.24-1.65L2,2.65l115.39-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.63,22.76l-9.16,117.13c-14.68,4.53-30.06,3.59-44.83-.2L23.79,24.35c4.26,1.3,10.02,8.03,14.57,7.38,6.07-.84,11.69-2.95,17.12-5.13,2.64-1.03,5.38-2.14,8.32-1.95,1.96.15,3.72.84,5.43,1.53,4.16,1.72,8.27,3.56,12.82,4.56,3.91.88,8.81-6.78,12.58-7.97Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.043fd54a1eb711cc3171a78287224458.svg";
export { ForwardRef as ReactComponent };